import {
  readSuppressedInheritedTags,
  SUPPRESSED_INHERITED_CULTURE_KEY,
  SUPPRESSED_INHERITED_HEALTH_KEY,
} from '../../services/GenogramPerspectiveProjection';

type SuppressionKey = typeof SUPPRESSED_INHERITED_CULTURE_KEY | typeof SUPPRESSED_INHERITED_HEALTH_KEY;

interface PersonLike {
  id: string;
}

export interface SuppressionUpdateSpec {
  nodeId: string;
  changes: { attrs: Record<string, string[]> };
}

export const collectSuppressedTags = (persons: PersonLike[], key: SuppressionKey): string[] =>
  Array.from(new Set(persons.flatMap(p => readSuppressedInheritedTags(p, key))));

export const buildSuppressionUpdates = (
  persons: PersonLike[],
  key: SuppressionKey,
  tag: string,
  suppress: boolean,
): SuppressionUpdateSpec[] =>
  persons.flatMap(p => {
    const current = readSuppressedInheritedTags(p, key);
    const has = current.includes(tag);
    if (has === suppress) return [];
    const next = suppress ? [...current, tag] : current.filter(t => t !== tag);
    return [{ nodeId: p.id, changes: { attrs: { [key]: next } } }];
  });
